module.exports = __webpack_public_path__ + "img/icon.2ed1c1bd.svg";